import { render, staticRenderFns } from "./CapLogosForm.vue?vue&type=template&id=c524a4ea&scoped=true"
import script from "./CapLogosForm.vue?vue&type=script&lang=js"
export * from "./CapLogosForm.vue?vue&type=script&lang=js"
import style0 from "./CapLogosForm.vue?vue&type=style&index=0&id=c524a4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c524a4ea",
  null
  
)

export default component.exports